import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StockLocation } from '../../../model/location/stock-location';
import { LocationsControllerRequestService } from '../../../services/api/locations-controller-request.service';
import { SnackService } from '../../../services/snack.service';

@Component({
  selector: 'stock-location-edit',
  templateUrl: './location-edit.component.html',
  styleUrls: ['./location-edit.component.scss'],
})
export class StockLocationEditComponent {
  @Input()
  location: StockLocation;

  @Output()
  saveSuccessEvent = new EventEmitter<StockLocation>();

  constructor(
    private locationsService: LocationsControllerRequestService,
    private snackService: SnackService
  ) {}

  save(): void {
    if (!this.validForSave()) {
      return;
    }

    if (this.location.id) {
      this.locationsService
        .update(this.location)
        .then((res) => {
          this.snackService.showSuccess('Locatie aangepast');
          this.saveSuccessEvent.emit(res);
        })
        .catch((err) => {
          this.snackService.showError('Locatie aanpassen mislukt'); //TODO reason?
        });
    } else {
      this.locationsService
        .create(this.location)
        .then((res) => {
          this.snackService.showSuccess('Locatie aangemaakt');
          this.saveSuccessEvent.emit(res);
        })
        .catch((err) => {
          this.snackService.showError('Locatie aanmaken mislukt'); //TODO show reason?
        });
    }
  }

  validForSave(): boolean {
    if (this.location.rack == null) {
      this.snackService.showError('Gelieve een rek te specifiëren');
      return false;
    }
    if (this.location.shelf == null) {
      this.snackService.showError('Gelieve een schap te specifiëren');
      return false;
    }
    if (this.location.compartment == null) {
      this.snackService.showError('Gelieve een vak te specifiëren');
      return false;
    }

    return true;
  }
}
